import React from 'react';
import { StatsGrid } from './stats/StatsGrid';
import { LatestProperties } from './LatestProperties';

export const Dashboard: React.FC = () => {
  return (
    <div className="space-y-8">
      <StatsGrid />
      <LatestProperties />
    </div>
  );
};